jQuery(function () {
  var selectors = {
    all: '[data-behaviour~="select-all"]',
    none: '[data-behaviour~="select-none"]',
  };
  var containerDataAttribute = "select-all-container";

  // BEHAVIOUR

  jQuery(document).on("click", selectors.all, selectAllHandler);
  jQuery(document).on("click", selectors.none, selectNoneHandler);

  // EVENTS HANDLERS

  function selectAllHandler(checked) {
    toggleCheckboxes(checkboxContainer(this), true);
  }

  function selectNoneHandler() {
    toggleCheckboxes(checkboxContainer(this), false);
  }

  // HELPER FUNCTIONS

  function toggleCheckboxes(container, checked) {
    container.find('[type="checkbox"]').prop("checked", checked).trigger("change");
  }

  function checkboxContainer(el) {
    var containerSelector = jQuery(el).data(containerDataAttribute);

    return containerSelector ? jQuery(containerSelector) : jQuery(el).closest("form");
  }
});
